import "./ContactInformation.html";

import "./EditSiteContactInformation/EditSiteContactInformationComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ContactInformationComponentController from "./ContactInformationComponentController";

export default class ContactInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = ContactInformationComponentController;
        this.templateUrl = "/App/Components/Site/Overview/ContactInformation/ContactInformation.html";
    }
}

module("mmManagePortal").component("mmSiteContactInformationEdit", new ContactInformationComponent());
